import { render, staticRenderFns } from "./sing-up.html?vue&type=template&id=52f5eb0b&scoped=true&"
import script from "./sing-up.js?vue&type=script&lang=js&"
export * from "./sing-up.js?vue&type=script&lang=js&"
import style0 from "./sing-up.scss?vue&type=style&index=0&id=52f5eb0b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f5eb0b",
  null
  
)

export default component.exports